export default __webpack_public_path__ + "static/ecuador-404295179cf7c0880758ae80d614bbc1.jpg";